import type {
  OrderItemForPriceSplit,
  OrderItemPriceSplit,
} from "../types/orders";

const UNIT_LABELS: Record<number, string> = {
  1: "kg",
  2: "lbs",
  3: "pieces",
};

export function getOrderItemParentQuantity(
  orderItem: OrderItemForPriceSplit | null | undefined,
): number {
  switch (parseInt(String(orderItem?.unit_type ?? ""), 10)) {
    case 1:
      return parseFloat(String(orderItem?.total_in_kg || 0));
    case 2:
      return parseFloat(String(orderItem?.total_in_lbs || 0));
    case 3:
      return parseFloat(String(orderItem?.total_in_pieces || 0));
    default:
      return 0;
  }
}

export function getOrderItemUnitLabel(
  unitType: number | string | null | undefined,
): string {
  const key = parseInt(String(unitType ?? ""), 10);
  return UNIT_LABELS[key] || "units";
}

export function sumOrderItemSplitQuantities(
  priceSplits: OrderItemPriceSplit[] | null | undefined,
  excludeSplitId: number | null = null,
): number {
  return (priceSplits || []).reduce((sum, split) => {
    if (excludeSplitId !== null && split.id === excludeSplitId) return sum;
    return sum + parseFloat(String(split.quantity || 0));
  }, 0);
}

export function getOrderItemRemainder(
  orderItem: OrderItemForPriceSplit | null | undefined,
): {
  quantity: number;
  unit_cost: number;
  subtotal_amount: number;
  tax_amount: number;
  total_cost: number;
} {
  const quantity =
    orderItem?.remainder_quantity != null
      ? parseFloat(String(orderItem.remainder_quantity))
      : getOrderItemParentQuantity(orderItem) -
        sumOrderItemSplitQuantities(orderItem?.price_splits);

  // Unallocated remainder is unpriced; pricing lives only on price splits.
  return {
    quantity,
    unit_cost: 0,
    subtotal_amount: 0,
    tax_amount: 0,
    total_cost: 0,
  };
}

export function formatSplitMoney(
  amount: string | number | null | undefined,
): string {
  const value =
    amount == null || amount === "" || Number.isNaN(Number(amount))
      ? 0
      : Number(amount);

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
}
